import { IThemeInterface } from '../../theme';
import { rem } from 'polished';
import { RecursivePartial } from '../../../interfaces/RecursivePartial';

export const breakpoints = {
    xs: 480,
    sm: 768,
    md: 992,
    lg: 1200,
};

const colors = {
    white: '#fff',
};

const themeOV: RecursivePartial<IThemeInterface> = {
    fonts: {
        fontBase: 'Vauxhall Neue',
        fontEmphasized: 'Vauxhall-Italic',
        fontSecondary: 'Arial',
    },
    fontSizes: {
        textSubMedium: rem('14px'),
        textBig: rem('18px'),
        h1: rem('36px'),
        h2: rem('30px'),
        h3: rem('24px'),
        h4: rem('18px'),
        h5: rem('14px'),
        h6: rem('12px'),
        h7: rem('10px'),
    },
    lineHeights: {
        h1: rem('39px'),
        h2: rem('32px'),
        h3: rem('26px'),
        h4: rem('20px'),
        h5: rem('18px'),
    },
    colors: {
        primary: '#C90C0F',
        secondary: '#A70F11',
        white: '#fff',
        primaryHover: colors.white,
        primaryDisabled: '#CDCDCD',
        secondaryHover: colors.white,
        secondaryDisabled: '#CDCDCD',
        trimPageModelNameBackground: '#f7f8f8',
        lozenge: '#C90C0F',
        lozengeArrow: '#4E0230',

        grey1: '#7F7F7F',
        grey2: '#A19A99',
        grey3: '#CAC6C5',
        grey4: '#e4e2e3',
        grey5: '#262626',
        grey6: '#f1f0f0',
        grey7: '#ececee',
        grey8: '#E5E5E5',
        grey9: '#818181',
        grey10: '#F2F2F2',
        grey11: '#BFBFBF',
        grey12: '#3C3947',
        grey13: '#B4B4B4',
        grey14: '#3B3938',
        grey15: '#444444',
        grey16: '#D9D9D9',
        grey17: '#E4E2E2',
        blue1: '#2885A1',
        black: '#1D1D1B',
        black2: '#000000',
        accordionSecondaryBg: colors.white,
        accessibilityOutlinecolor: '#C90C0F',
    },
    fontWeights: {
        textLight: 300,
        textRegular: 400,
        textMedium: 500,
        textBold: 600,
        textExtraBold: 800,
    },
};
export default themeOV;
